import { HttpService } from '@/infra/http'

export class GetSimulacaoPdfService extends HttpService {
  execute = async (simulacaoId: string, exibirDividendos?: boolean) => {
    return this.http.get<Blob>(`api/v2/Simulacao/pdf/${simulacaoId}`, {
      responseType: 'blob',
      params: { exibirDividendos },
    })
  }
}
